// Theme (light / classic dark) for the Work Desk internal app. Persists in localStorage.
import { createContext, useContext, useEffect, useState } from "react";

const ThemeContext = createContext(null);

function initialTheme() {
  try {
    return localStorage.getItem("workdesk-theme") || "light";
  } catch {
    return "light";
  }
}

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(initialTheme);

  useEffect(() => {
    document.documentElement.classList.toggle("dark", theme === "dark");
    try {
      localStorage.setItem("workdesk-theme", theme);
    } catch {
      /* storage unavailable */
    }
  }, [theme]);

  const toggle = () => setTheme((t) => (t === "dark" ? "light" : "dark"));

  return <ThemeContext.Provider value={{ theme, toggle }}>{children}</ThemeContext.Provider>;
}

export function useTheme() {
  return useContext(ThemeContext);
}
